import React from 'react';
import Lottie from 'react-lottie';
import classNames from 'classnames';
import { motion } from 'framer-motion';
import * as animationDataLight from '../../data/hinlogo-light.json';
import * as animationDataDark from '../../data/hinlogo-dark.json';
import * as styles from './logo.module.scss';

const Logo = ({ variant, isSmall }) => {
  const defaultOptions = {
    loop: false,
    autoplay: true,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice'
    },
  };

  const lightOptions = {
    animationData: animationDataLight.default,
    ...defaultOptions
  };

  const darkOptions = {
    animationData: animationDataDark.default,
    ...defaultOptions
  };

  const variants = {
    hidden: {
      opacity: 0,
    },
    visible: {
      opacity: 1,
    },
  };

  return (
    <div
      className={classNames(styles.logo, {
        [styles.small]: isSmall
      })}
    >
      <motion.div
        className={styles.inner}
        variants={variants}
        animate={variant === 'light' ? 'visible' : 'hidden'}
      >
        <Lottie
          options={lightOptions}
          direction={isSmall ? 1 : -1}
          height="auto"
          width="auto"
          isClickToPauseDisabled
        />
      </motion.div>

      <motion.div
        className={styles.inner}
        variants={variants}
        animate={variant === 'dark' ? 'visible' : 'hidden'}
      >
        <Lottie
          options={darkOptions}
          direction={isSmall ? 1 : -1}
          height="auto"
          width="auto"
          isClickToPauseDisabled
        />
      </motion.div>
    </div>
  );
};

export default Logo;
